import moment from 'moment'

import FallbackPhoto from '../assets/images/program-builder/junior-with-coach.webp'

const CERTIFICATIONS_PATH = '/portal/certifications'
export const VIDEO_COMPLETION_THRESHOLD = 0.9

export const certificationPath = (certificationId) => `${CERTIFICATIONS_PATH}/${certificationId}`

export const sectionsPath = (certificationId) => `${certificationPath(certificationId)}/sections`

const lessonPath = (item) => `${certificationPath(item.certificationId)}/lessons/${item.id}`

const quizPath = (item) => `${certificationPath(item.certificationId)}/quizzes/${item.id}`

export const itemPath = (item) => (item.type === 'lesson' ? lessonPath(item) : quizPath(item))

const quizItem = (certification, quiz, section, sectionIndex) => ({
  type: 'quiz',
  id: quiz.id,
  certificationId: certification.id,
  quiz,
  section,
  sectionIndex,
  final: !section,
  available: quiz.available,
  done: quiz.passed,
})

const lessonItem = (certification, lesson, section, sectionIndex, lessonIndex) => ({
  type: 'lesson',
  id: lesson.id,
  certificationId: certification.id,
  lesson,
  section,
  sectionIndex,
  lessonIndex,
  available: lesson.available,
  done: lesson.completed,
})

export const certificationItems = (certification) => {
  const items = certification.sections.flatMap((section, sectionIndex) => [
    ...section.lessons.map((lesson, lessonIndex) => lessonItem(certification, lesson, section, sectionIndex, lessonIndex)),
    ...(section.quiz ? [quizItem(certification, section.quiz, section, sectionIndex)] : []),
  ])

  return certification.finalQuiz ? [...items, quizItem(certification, certification.finalQuiz, null, certification.sections.length)] : items
}

export const findItem = (items, type, id) => items.find(item => item.type === type && item.id === id)

export const nextItem = (items, item) => items[items.indexOf(item) + 1] || null

export const previousItem = (items, item) => items[items.indexOf(item) - 1] || null

const itemsBefore = (items, quiz) => (quiz.final ? items : sectionItems(items, quiz.section)).filter(item => item !== quiz)

const opensAfter = (items, quiz, current) => itemsBefore(items, quiz).every(item => item.done || item === current)

export const nextTarget = (items, current) => {
  const next = nextItem(items, current)
  if (!next) { return null }
  if (next.type === 'lesson' || next.available || opensAfter(items, next, current)) { return next }

  const before = itemsBefore(items, next).filter(item => !item.done && item !== current)

  return before.find(item => item.type === 'lesson') || before.find(item => item.available) || null
}

export const resumeItem = (items) => items.find(item => !item.done && item.available) || items.find(item => item.available) || null

export const sectionItems = (items, section) => items.filter(item => item.section?.id === section.id)

export const itemsProgress = (own) => ({
  done: own.filter(item => item.done).length,
  total: own.length,
  available: own.some(item => item.available || item.done),
})

export const quizzesCount = (certification) => certification.sections.filter(section => section.quiz).length + (certification.finalQuiz ? 1 : 0)

export const lessonsCount = (certification) => certification.sections.reduce((count, section) => count + section.lessons.length, 0)

export const isCertified = ({ certified, enrollment }) => !!certified || enrollment?.status === 'completed'

export const certificationStatus = ({ enrollmentStatus, certified }) => {
  if (enrollmentStatus === 'in_progress') { return 'in_progress' }
  if (certified) { return 'certified' }

  return enrollmentStatus || null
}

export const isInProgress = (certification) => certification.enrollment?.status === 'in_progress'

export const isKitLoading = (enrollment, kitStatus) => !enrollment.kitReady && kitStatus === 'loading'

export const formatDate = (date) => moment(date).format('D MMM YYYY')

export const coverImageUrl = (certification) => certification.coverImage?.largeFileUrl || FallbackPhoto

